import { GraduationCap, Clock, MapPinLine, ShieldStar } from '@phosphor-icons/react';

export const TrustBar = () => {
  const trustItems = [
    {
      icon: GraduationCap,
      label: "MBA-Led",
      sublabel: "Corporate-Grade Service",
    },
    {
      icon: Clock,
      label: "24 / 7",
      sublabel: "Same-Day Availability",
    },
    {
      icon: MapPinLine,
      label: "Nashville Local",
      sublabel: "All of Middle TN",
    },
    {
      icon: ShieldStar,
      label: "5.0 ★ Google",
      sublabel: "Bonded & Commissioned",
    },
  ];

  return (
    <section data-testid="trust-bar-section" className="bg-white border-y border-[#E8E2D5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {trustItems.map((item, index) => (
            <div
              key={index}
              data-testid={`trust-item-${index}`}
              className="flex items-center gap-4 justify-center group"
            >
              <div className="w-12 h-12 rounded-full bg-[#800000]/5 flex items-center justify-center group-hover:bg-[#D4AF37]/15 transition-colors">
                <item.icon weight="duotone" size={26} className="text-[#800000] group-hover:text-[#D4AF37] transition-colors" />
              </div>
              <div>
                <p className="font-serif-display font-semibold text-[#800000] text-lg leading-tight">{item.label}</p>
                <p className="text-xs text-[#5C5C5C] tracking-wide uppercase mt-0.5">{item.sublabel}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
